import { render, staticRenderFns } from "./BenefitsMtRu.vue?vue&type=template&id=d1b76c2e"
import script from "./BenefitsMtRu.vue?vue&type=script&lang=js"
export * from "./BenefitsMtRu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports